import React, { useState, useEffect } from "react";
import PartnerCompany from "../AllPageComponents/PartnerCompany/PartnerCompany";
import "../CarInsurnce/Carinsurence.css";
import FAQ from "../AllPageComponents/FAQ/FAQ";
import { LuAlarmClock } from "react-icons/lu";
import CarInsuranceForm from "./CarInsuranceForm";
import Redirect from "../AllPageComponents/Rederict";
import FastImage from "../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { MdOutlineExpandMore } from "react-icons/md";
import { GrDocumentText } from "react-icons/gr";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { IoCarSportSharp } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import { LuPhone } from "react-icons/lu";

const Carinsurence = () => {
  // carNumber Validation

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    car_number: "",
    phone_no: "",
    pin: "",
    car_type: "fourwheeler",
    name: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [isLoading, setisLoading] = useState(false);

  const validateCarNumber = () => {
    const carValidateRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/;
    const isValid = carNumber.length === 10 && carValidateRegex.test(carNumber);
    if (isValid) {
      //console.log("Valid car number");
    } else {
      //console.log("Invalid car number");
    }
    return isValid;
  };

  const carNumber = formData.car_number;
  useEffect(() => {
    validateCarNumber();
  }, [carNumber]);
  const isValid = validateCarNumber();

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const [isTextExpand, setisTextExpand] = useState(false);

  const ToggleTextExpand = () => {
    setisTextExpand(!isTextExpand);
  };

  const QNAARRAY = [
    {
      id: 0,
      Q: "Third Party Bodily Injuries",
      A: "All bodily Injuries caused to someone else by your car in an accident will be compensated for by your insurance provider",
    },
    {
      id: 1,
      Q: "Third Party Disability",
      A: "If an accident caused by your car results in a disability of a third party, then the compensation for the same will be provided",
    },
    {
      id: 2,
      Q: "Third party Death",
      A: "Compensation will be provided in case an accident caused by your car results in a demise of a third party.",
    },
    {
      id: 3,
      Q: "Third Party Property Damage",
      A: "Damages caused to a third party’s property will be covered up to Rs. 7.5 Lakh.",
    },
    {
      id: 4,
      Q: "Road Accidents",
      A: "Damages caused to your car in accidents or collisions will be covered.",
    },
    {
      id: 5,
      Q: "Natural Calamities",
      A: "Damages sustained by your car in natural disasters such as earthquakes, floods, cyclones, etc. will be covered.",
    },
    {
      id: 6,
      Q: "Man-made Disasters",
      A: "Damages incurred by your car in man-made disasters like riots, strikes, terrorism, vandalism, etc will be covered.",
    },
    {
      id: 7,
      Q: "Damage During Transit",
      A: "Damages caused to your car during transit by road, rail, inland waterway, and lift will be covered.",
    },
    {
      id: 8,
      Q: "Fire/Explosion",
      A: "Damages sustained by your car in fire and explosions will be covered.",
    },
    {
      id: 9,
      Q: "Theft of Your Car",
      A: "Loss of your car due to theft or burglary is covered.",
    },
  ];

  const QNAARRAY2 = [
    {
      id: 10,
      Q: "Drunk Driving:",
      A: "Any claims from incidents where the driver was under the influence of alcohol will not be accepted.",
    },
    {
      id: 11,
      Q: "Driving Without a Valid Driver’s License",
      A: "If the driver didnt have a valid license at the time of the incident, there is no coverage.",
    },
    {
      id: 12,
      Q: "Wear and Tear/Depreciation",
      A: "Routine wear and tear, as well as depreciation, are not covered.",
    },
    {
      id: 13,
      Q: "Consumables",
      A: " Items like engine oil, brake oil, air conditioner refrigerant, radiator coolant, nuts, bolts, screws, washers, and grease are not covered.",
    },
    {
      id: 14,
      Q: "Mechanical/Electrical Breakdown:",
      A: " Any mechanical or electrical breakdowns are excluded from coverage.",
    },
    {
      id: 15,
      Q: "Driving Under the Influence of Drugs",
      A: "Claims are not accepted if the driver was under the influence of drugs.",
    },
    {
      id: 16,
      Q: "Damage in War/Nuclear Attack:",
      A: "Any damages resulting from war or nuclear activities are not covered.",
    },
    {
      id: 17,
      Q: "Damage to Tyres/Tubes Except in Accidents:",
      A: "Damages to tyres and tubes are only covered if they result from an accident.",
    },
    {
      id: 18,
      Q: "Damage Incurred Outside Covered Geographical Boundaries:",
      A: "Damages occurring outside the specified geographical limits of the policy are not covered",
    },
  ];

  const QNAARRAYCover = [
    {
      id: 19,
      Q: "Third Party Bodily Injuries",
      A: "All bodily Injuries caused to someone else by your car in an accident will be compensated for by your insurance provider",
    },
    {
      id: 20,
      Q: "Third Party Disability",
      A: "If an accident caused by your car results in a disability of a third party, then the compensation for the same will be provided",
    },
    {
      id: 21,
      Q: "Third party Death",
      A: "Compensation will be provided in case an accident caused by your car results in a demise of a third party.",
    },
    {
      id: 22,
      Q: "Third Party Property Damage",
      A: " Damages caused to a third party’s property will be covered up to Rs. 7.5 Lakh.",
    },
    {
      id: 23,
      Q: "Mechanical/Electrical Breakdown:",
      A: " Any mechanical or electrical breakdowns are excluded from coverage.",
    },
    {
      id: 24,
      Q: "Road Accidents",
      A: "Damages caused to your car in accidents or collisions will be covered.",
    },
    {
      id: 25,
      Q: "Natural Calamities",
      A: "Damages sustained by your car in natural disasters such as earthquakes, floods, cyclones, etc. will be covered.",
    },
    {
      id: 26,
      Q: "Man-made Disasters:",
      A: "Damages incurred by your car in man-made disasters like riots, strikes, terrorism, vandalism, etc will be covered.",
    },
    {
      id: 27,
      Q: "Damage During Transit",
      A: "Damages caused to your car during transit by road, rail, inland waterway, and lift will be covered.",
    },
  ];

  const QNAARRAY3 = [
    {
      id: 19,
      Q: "Understand the Different Insurance Types",
      A: "There are three types of car insurance policies: third-party, own-damage, and comprehensive. Assess your needs carefully. A third-party policy ensures legal compliance, while a comprehensive plan offers full protection for your vehicle. At Beema1, we offer all three types, so you can select the one that fits your needs and budget.",
    },
    {
      id: 20,
      Q: "Analyze the Car Insurance Premium",
      A: "The premium depends on factors like IDV, car model, fuel type, and age. Premiums vary between insurers, so it’s essential to compare them. Ensure you choose a plan that fits your budget without compromising on coverage.",
    },
    {
      id: 21,
      Q: "Check the IDV",
      A: "The Insured Declared Value (IDV) is the current market value of your car. It decreases as your vehicle ages and undergoes wear and tear. The IDV is the maximum amount the insurer will pay if your car is completely damaged or stolen. A higher IDV means a higher premium, so choose wisely.",
    },
    {
      id: 22,
      Q: "Compare Different Plans",
      A: "Comparing car insurance policies online helps you find the best plan for your needs and budget. Analyze the coverage offered by different plans to make an informed decision.",
    },
    {
      id: 23,
      Q: "Consider Add-ons",
      A: "Enhance your plan with add-ons like zero depreciation cover, no claim bonus, key loss cover, and engine protection. Adding these options provides extra coverage and ensures comprehensive protection for your vehicle.",
    },
    {
      id: 24,
      Q: "Look for Cashless Garages",
      A: "Cashless garages allow you to get repairs done without paying upfront. Choose an insurer with a wide network of cashless garages for hassle-free repairs and claims settlement",
    },
    {
      id: 25,
      Q: "Check the Claim Settlement Ratio",
      A: "The Claim Settlement Ratio (CSR) reflects the insurers efficiency in settling claims. A higher CSR indicates a reliable insurer. Opt for a company with a simple and quick claim process and a high CSR.",
    },
    {
      id: 26,
      Q: "Evaluate Services Offered",
      A: "Beyond CSR, consider the services provided by the insurer. Look for features like quick claim settlement, 24/7 customer service, and other support services. Choose a company known for hassle-free customer service.",
    },
  ];

  const QNAARRAY4 = [
    {
      id: 27,
      Q: "Zero Paperwork",
      A: "Our application process is fully digital, requiring only scanned copies of documents, minimizing or eliminating paperwork.",
    },
    {
      id: 28,
      Q: "Cost-effective",
      A: "By cutting out the middleman, we reduce commission costs and offer frequent discounts, making insurance more affordable.",
    },
    {
      id: 29,
      Q: "Convenient and Time Effective",
      A: "No more being restricted by branch hours or agent availability. Buy your policy whenever it suits you best.",
    },
    {
      id: 30,
      Q: "Payment Reminders",
      A: "Our mobile app sends regular reminders, ensuring you never miss a payment due date.",
    },
    {
      id: 31,
      Q: "Pay Premium Online",
      A: "Embrace the convenience of digital payments. Our platform supports all online payment methods.",
    },
    {
      id: 32,
      Q: "Easy Endorsement",
      A: "Updating your policy is as simple as submitting a self-declaration and verifying the amended information with your insurer.",
    },
    {
      id: 33,
      Q: "Soft Copy of the Document",
      A: "Receive a digital copy of your insurance policy via email and our mobile app, keeping your documents easily accessible.",
    },
    {
      id: 34,
      Q: "Physical Damage to Your Car",
      A: "Get protection for repair expenses resulting from accidents, ensuring your car is back on the road quickly.",
    },
    {
      id: 35,
      Q: "Liability Towards Third-Party",
      A: "Stay covered for legal liabilities arising from the death or disability of a third party due to an accident involving your car.",
    },
    {
      id: 36,
      Q: "Liability Towards Property",
      A: "Protect yourself from third-party property liability in case of damage or destruction caused by your vehicle.",
    },
    {
      id: 37,
      Q: "Personal Accident Cover",
      A: "Benefit from a personal accident cover of Rs. 15 lakh, safeguarding not just your vehicle but also you, third parties, and their property.",
    },
    {
      id: 38,
      Q: "Complete Peace of Mind",
      A: "Enjoy your road trips worry-free, knowing you're protected from financial losses.",
    },
  ];

  const [expanded, setExpanded] = useState(null);

  const handleChangese = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const pointtoremember = [
    {
      id: 1,
      Q: "Affordable term plan ",
      A: " The premium of a financially reasonable term plan is based on the age and health conditions of the policyholder. The premium amount is low for non-smokers and for the policy holders leading a healthy lifestyle and the premium would be charged at a higher rate if the policy holder is a smoker or leads an unhealthful lifestyle. Hence, it is advisable to select a term plan at an early age, preferably whenever you start earning, as one can get insured with higher coverage at a very pocket-friendly premium.",
    },
    {
      id: 2,
      Q: "Policy benefits",
      A: "Please refer to all the benefits and the living benefits those are the part of a term insurance plan before you purchase one. Most of the term plans includes terminal illness or accidental death rider at nil or zero cost. Hence, it is always beneficial to check such minor and major details regarding the policy benefits and how the nominee will receive the payment or how the policyholder will be paid at the time of unfortunate events.",
    },
    {
      id: 3,
      Q: "Avail term insurance plan through online platforms",
      A: " It is also wise to purchase the term plan through the online platforms rather than through any agent. Online plans are available with comparatively better options and reasonable offers or discounts than that of the offline options. Insurance plans you opt for through online platforms are available at lower premium rates. Therefore, instead of approaching any insurance agent you may conveniently avail the best term insurance plan through the online platforms.",
    },
    {
      id: 4,
      Q: "Claim settlement ratio of term insurance plans (CSR)",
      A: "It is vital to consider the CSR of the insurance company when you choose the best term insurance plan for yourself and which portrays the number of claims settled and paid by the insurance provider against the exact number of claims filed by the policyholder or their nominees. CSR higher than 80% is usually considered as a decent claim settlement ratio.",
    },
    {
      id: 5,
      Q: "Be smart while choosing your term insurance policy",
      A: "Entering the policy tenure and sum assured coverage as per your future needs and requirements is a must while applying for a term insurance plan online. Your policy term ends at 10,20, or 30 years, if you renew your term insurance plan up to a certain age, it might be expensive for you as you will be renewing your policy at a later age. An insurance advisor will advise you to renew your term insurance policy till the time you retire so that you do not end up paying high renewal expenses.",
    },
  ];

  const typeofcarinsurence = [
    {
      id: 1,
      icon: <IoCarSportSharp />,
      Q: "Comprehensive Car Insurance",
      A: "Considered the top choice among car owners, this insurance policy offers extensive coverage for both your vehicle and third-party damages. True to its name, comprehensive insurance provides financial support for a wide range of situations, including damages from natural disasters, accidents, theft, and more. It's the all-in-one solution for peace of mind on the road",
    },
    {
      id: 2,
      icon: <IoCarSportSharp />,
      Q: "Third-party Car Insurance",
      A: "If you're hitting the road in India, you've got to have third-party four-wheeler insurance—it's the law! This policy steps in to cover any injuries, disabilities, or even unfortunate fatalities of third parties involved in an accident with your car. Plus, it kicks in to cover any property damage too, up to Rs. 7.5 Lakh. It protects against any legal liability to a third party caused to accidents with a consequence of bodily injuries, property damages, or death. It does not compensate for any damage caused to the insured’s vehicle",
    },
    {
      id: 3,
      icon: <IoCarSportSharp />,
      Q: "Own Damage Car Insurance",
      A: "In September 2019, the Insurance Regulatory and Development Authority of India (IRDAI) introduced the Standalone Own-Damage car insurance policy. This unique plan provides coverage exclusively for the damages incurred by your vehicle in various scenarios like accidents, natural disasters, fires, theft, and other unfortunate events",
    },
    {
      id: 4,
      icon: <IoCarSportSharp />,
      Q: "Third-Party Car Insurance vs Comprehensive Car Insurance",
      A: "To help you in selecting the perfect car insurance policy, check out the comparison table below. It highlights the features offered under various types of car insurance policies in India:",
    },
  ];

  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const [isVisible, setIsVisible] = useState(false); // Changed state name
  const handleToggle = () => {
    // Changed function name
    setIsVisible(!isVisible);
  };

  const stepsArray = [
    {
      id: 1,
      Q: "Step 1: Report the Incident:",
      A: "As soon as an accident occurs, notify your insurer immediately. Provide comprehensive details of the incident and support your claim with photographic evidence, if possible.",
    },
    {
      id: 2,
      Q: "Step 2: Vehicle Inspection:",
      A: "Once the claim is filed, the insurer will send a surveyor to assess the damage. Keep all relevant documents ready for verification during this process.",
    },
    {
      id: 3,
      Q: "Step 3: Repairs:",
      A: "After the inspection, you can proceed to send your car to a network garage for repairs.",
    },
    {
      id: 4,
      Q: "Step 4: Settlement:",
      A: "If you have opted for cashless claim settlement, the insurer will directly settle the repair bills with the network garage. For reimbursement claims, you'll need to pay the bills upfront and then file for reimbursement later.",
    },
  ];

  const [isPanelExpanded, setPanelExpanded] = useState(false);

  const handlePanelChange = (panel) => (event, isExpanded) => {
    setPanelExpanded(isExpanded ? panel : false);
  };

  const [readmore, setreadmore] = useState(true);

  const handelReadmore = () => {
    setreadmore(!readmore);
  };

  const [activeId, setActiveId] = useState(null);

  const toggleOpen = (id) => {
    setActiveId(id === activeId ? null : id);
  };

  return (
    <div>
      <section className="car-insurance insurance-all car-main mainnargin-insurance">
        <div className="container">
          <Redirect />
          <div className="row insurance-row-one">
            <div className="col-sm-12 col-md-4 col-lg-4 mian-one">
              <div className="healthdiscription">
                {/* <h1>Buy Four Wheeler Insurance Online</h1> */}
                <h1>
                  Secure your interests with the best car insurance plan today
                </h1>
                {isExpanded ? (
                  <p className="normaltext">
                    So, let's talk wheels! Life is cool when you’re driving.
                    Breaking in your new ride like a boss, fresh off the lot,
                    you feel the horsepower and it’s undoubtedly addictive. But
                    wait, hold on. Roads are not made only for adventures,
                    journeys or cool car pics. The smoothest road you drive on
                    or the best paved surface in the world may lead you to the
                    deadliest car accidents you can ever imagine. Hence, car
                    insurance, also known as motor insurance, is like a safety
                    net for your ride and for your car. It's there for you, to
                    provide you financial protection if your car gets into a
                    scrape—whether it's a road accident, theft, or even fire.
                    But wait, there's more! It also covers damages from natural
                    disasters, run-ins with critters, and even accidents caused
                    by other drivers. And don't forget about third-party
                    coverage, which kicks in if your car accidentally causes
                    harm to someone else's property or worse, injures them.
                    Having a valid third-party insurance policy isn't just a
                    great idea—it's the law. It keeps you on the right side of
                    the Motor Vehicles Act, of 1988. Find the best car insurance
                    rates - compare and save today by getting affordable full
                    coverage car insurance. To compare things, it's best to
                    think of similarities. For contrast, think of differences.
                    Here, Beema1 provides you with data information in
                    categories formatted into easily explained methods, using
                    exact facts and figures
                    <a
                      style={{ color: "#0166B3", cursor: "pointer" }}
                      onClick={toggleExpansion}
                    >
                      Show Less
                    </a>
                  </p>
                ) : (
                  <>
                    <p className="normaltext">
                      So, let's talk wheels! Life is cool when you’re driving.
                      Breaking in your new ride like a boss, fresh off the lot,
                      you feel the horsepower and it’s undoubtedly addictive.
                      But wait, hold on. Roads are not made only for adventures,
                      journeys or cool car pics.
                    </p>

                    <a
                      style={{ color: "#0166B3", cursor: "pointer" }}
                      onClick={toggleExpansion}
                    >
                      Show More
                    </a>
                  </>
                )}
              </div>
              <div className="d-flex gap-4">
                <div className="insurance-btn-set">
                  <button
                    type="button"
                    className="reminderbutton"
                    data-toggle="modal"
                    data-target="#reminderpopup"
                  >
                    {" "}
                    <LuAlarmClock
                      fontSize={"15pt"}
                      style={{ margin: "0 5px", color: "#FBA71B" }}
                    />{" "}
                    Set Reminder
                  </button>
                </div>
                <div className="insurance-btn-set mx-2">
                    <a href="tel:9051911171" className="reminderbutton" style={{ textDecoration: "none" }}>
                      <LuPhone
                        fontSize={"13pt"}
                        style={{ margin: "0 5px", color: "#FBA71B" }}
                      />
                      Call Now
                    </a>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 side-image">
              <FastImage
                url={"Website%20Img/carImagMascord.png?updatedAt=1718773961090"}
                width={auto}
                height={auto}
                alt={"Car Insurance in India"}
                className="carinsurence"
              />
            </div>
            <style
              dangerouslySetInnerHTML={{
                __html: "\n    .hide{\n        display: none;\n    }\n",
              }}
            />

            <CarInsuranceForm />
          </div>
        </div>
      </section>
      <div className="inbulitmargine"></div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">What is Car Insurance?</h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center align-items-center">
              {isTextExpand ? (
                <p className="normaltext">
                  A car insurance is a contract between you and the insurance
                  company that protects and safeguards you against financial
                  loss in the event of an accident or theft. In exchange for a
                  small fee, insurance companies provide financial protection to
                  four-wheelers against unexpected events such as accidents,
                  theft, fires, natural disasters, and third-party liabilities.
                  Plus, having valid car insurance can help you avoid hefty
                  traffic fines. Car insurance covers the loss or damage to a
                  car that is caused by an accident. Car insurance covers
                  damages and defilements to the car's body, engine and other
                  parts, but it does not cover the loss of personal belongings
                  inside the car. Now, there are three main types of car
                  insurance policies to choose from: third-party, own damage,
                  and comprehensive. Plus, as a car owner, you can opt for a
                  Personal Accident Cover of up to INR 15 Lakh to make sure you
                  and your driver are covered in case of any accidents. In the
                  expeditiously evolving landscape of automatized technology and
                  insurance, the year 2024 holds the assurance for important
                  metamorphosis and evolution in the field of car insurance.
                  With the development in the upgradation of telematics, the
                  expansion of electric vehicles (EVs), and as the Insure Tech
                  has sprung up, the future of car insurance is for innovation
                  and adaptation and modification to ever-demanding consumer
                  needs and inclinations and predilections. When you buy or
                  lease a car, it's very much required and essential to protect
                  that investment. Getting your auto insured can offer you
                  reassurance, assistance and confidence in case you're involved
                  in an accident or your vehicle is stolen, vandalized or
                  damaged by any natural disaster. Instead of paying
                  out-of-pocket for auto accidents, people pay annual premiums
                  to an auto insurance company; the company then pays off all or
                  most of the expenses related to an auto accident or other
                  vehicle damage or vehicle impairment.
                  <br />
                  <li>
                    Car insurance is a calculated measure that works as a shield
                    designed and steered to protect you against monetary
                    erosion, if you're involved in an accident or the vehicle is
                    damaged in some way
                  </li>
                  <br />
                  <li>
                    Most of the Indian states require you to have at least
                    minimum amounts of liability insurance coverage. Some also
                    need you to have other coverage types, such as integrated
                    motorist coverage
                  </li>
                  <br />
                  <li>
                    Premiums are what you pay on monthly, biannually or yearly
                    basis to maintain your car insurance policy while
                    deductibles are the amounts you pay when you file a claim
                  </li>
                  <br />
                  <li>
                    It's very essential to look around for the best car
                    insurance rates to wisely choose the right coverage for your
                    vehicle at the right price.
                  </li>
                  &nbsp;
                  <a
                    style={{ color: "#0166B3", cursor: "pointer" }}
                    onClick={ToggleTextExpand}
                  >
                    Show less
                  </a>
                </p>
              ) : (
                <p className="normaltext">
                  {" "}
                  A car insurance is a contract between you and the insurance
                  company that protects and safeguards you against financial
                  loss in the event of an accident or theft. In exchange for a
                  small fee, insurance companies provide financial protection to
                  four-wheelers against unexpected events such as accidents,
                  theft, fires, natural disasters, and third-party liabilities.
                  Plus, having valid car insurance can help you avoid hefty
                  traffic fines. Car insurance covers the loss or damage to a
                  car that is caused by an accident. Car insurance covers
                  damages and defilements to the car's body, engine and other
                  parts, but it does not cover the loss of personal belongings
                  inside the car. &nbsp;
                  <a
                    style={{ color: "#0166B3", cursor: "pointer" }}
                    onClick={ToggleTextExpand}
                  >
                    Show more
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">Types Of Car Insurance</h1>
          <div className="yellowline"></div>
          <p className="normaltext">
            At Beema1, you can buy three different types of car insurance
            policies, including third-party insurance, comprehensive insurance,
            and standalone own-damage insurance
          </p>
          <div className="row justify-content-start">
            {typeofcarinsurence.map((data, index) => {
              return (
                <div className="col-md-6 py-2" key={index}>
                  <div className="cards">
                    <div className="headterm">
                      {/* <p className="iconsize">{data.icon}</p> */}
                      <h3>{data.Q}</h3>
                    </div>

                    <div className="textclass">
                      <p className="normaltext">
                        {data.A.slice(0, 300) + "...."}
                      </p>

                      {/* Check if listone exists and map over it */}
                      {data.listone && data.listone.length > 0 && (
                        <>
                          {data.listone.map((item, i) => (
                            <li key={i} className="listtagessterm">
                              {item}
                            </li>
                          ))}
                        </>
                      )}
                    </div>

                    <div className="buttontext">
                      <button>Check Premium</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Third-Party Car Insurance vs Comprehensive Car Insurance
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="normaltext">
                To help you in selecting the perfect car insurance policy, check
                out the comparison table below. It highlights the features
                offered under various types of car insurance policies in India
              </p>

              <div className="tableoverflow">
                <table className="comparativeCarInsurance-table comparativeCarInsurance-table-bordered">
                  <thead>
                    <tr>
                      <th>Key Points</th>
                      <th>Comprehensive Insurance</th>
                      <th>Third-party Insurance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="comparativeCarInsurance-row">
                      <td>Definition</td>
                      <td>
                        Comprehensive coverage provides complete protection for
                        your car as well as third-party liabilities.
                      </td>
                      <td>
                        Third-party insurance provides protection only if a
                        third party is damaged due to the insured vehicle.
                      </td>
                    </tr>
                    <tr>
                      <td>Coverage</td>
                      <td>
                        It covers the financial loss to the insured car and a
                        third-party.
                      </td>
                      <td>
                        It provides financial compensation if there is damage to
                        a third party.
                      </td>
                    </tr>
                    <tr className="comparativeCarInsurance-row">
                      <td>Legal Requirement</td>
                      <td>No, this type of policy is not legally required.</td>
                      <td>
                        As per the Motor Vehicles Act of 1988, this type of
                        policy is a mandatory requirement.
                      </td>
                    </tr>
                    <tr>
                      <td>Cost</td>
                      <td>
                        As it offers more coverage, it is generally costlier.
                      </td>
                      <td>
                        It is more affordable as compared to a comprehensive
                        plan.
                      </td>
                    </tr>
                    <tr className="comparativeCarInsurance-row">
                      <td>Exclusions</td>
                      <td>
                        Any damage to the insured car or a third party is not
                        covered if you are driving under the influence of
                        alcohol or drugs.
                      </td>
                      <td>Any damage to the vehicle is not covered.</td>
                    </tr>
                    <tr>
                      <td>Add-ons</td>
                      <td>
                        Several add-ons can be included in a comprehensive plan.
                      </td>
                      <td>
                        You can include add-ons in a third-party insurance.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why Car Insurance Plan Is Important and What Does Auto Insurance
            Coverage Protect ?
          </h1>
          <div className="yellowline"></div>
          <p className="normaltext" style={{ textAlign: "justify" }}>
            An auto insurance policy will not cover you and your family members
            on the policy, whether driving someone else’s car (with their
            permission). Your policy also doesn’t provide coverage to someone
            who is not on your policy and is driving your car with your consent.
            That particular insurance policy will cover the personal loss caused
            to any person on third party damage but the same will not provide
            any coverage for personal loss to you or your family even though you
            drive someone else’s car with his/her due permission. Personal auto
            insurance only covers personal driving. It will not provide coverage
            if you use your car for any commercial purposes—such as making
            delivery services. Neither will it provide coverage if you use your
            personal car for ride-sharing services such as Uber, Ola or Lyft.
            For utilizing your personal car for commercial purposes, you need to
            intimate the Regional Transport Office or Road Transport Office
            (RTO) office and transform the status of your car into a commercial
            vehicle span
          </p>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <span className="specialprice">
                  The Ultimate Essence Of Car insurance:-
                </span>
                <p className="normaltext" style={{ textAlign: "justify" }}>
                  Other types of insurance such as health insurance and
                  homeowner’s insurance may seem more important, but if you own
                  an automobile insurance policy, it can help you save a lot of
                  money and save you from causing botheration and difficulties
                  in the long run. So, do not miss to browse, compare and buy
                  from Bheema 1 for the best car insurance rates to explore,
                  locate and choose your required coverage at a price you can
                  afford. Get access to the four-wheeler insurance quotes from
                  our car insurance comparison page on the website of Beema1.
                </p>

                <span className="specialprice">Premium Calculator:-</span>
                <p className="normaltext" style={{ textAlign: "justify" }}>
                  Secure your interests with the best low-cost car insurance
                  policy today. Calculate your premium with the help of an
                  online premium calculator and get the best car insurance in
                  India with an online discount. You will be well equipped with
                  information and once you browse through with the help of the
                  best car insurance rate finder and receiving the best online
                  four-wheeler quotes from the Beema1 team experts. Vehicle
                  insurance premium calculator is advantageous. Vehicle
                  insurance is obligatory in India according to laws and legal
                  bodies. Vehicle insurance assures contentment by moderation of
                  the unpredicted expenses caused by accidents or legal
                  responsibilities. Vehicle insurance should not be purchased
                  under pressure. Purchasing of vehicle insurance should be
                  based on providing ultimate protection through a financial
                  armor to the insured vehicle under the circumstances of any
                  mis-happenings or phenomenon.
                </p>
              </div>
            </div>

            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/car_14395424.png?updatedAt=1729850372625"
                width={auto}
                height={auto}
                alt={"Car Insurance in India"}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How To Choose The Right Car Insurance Policy Online?
          </h1>
          <div className="yellowline"></div>

          <p className="normaltext">
            <b>Drive Worry-Free with Beema1</b>
            <br />
            When it comes to choosing the perfect car insurance policy, there
            are a bunch of things to consider. Factors like coverage options,
            claim settlement track record, availability of cashless repairs, and
            more all play a role in finding the right fit for you. Check out
            some of the key factors listed below:
          </p>
          <div className="row">
            <div className="col-md-12">
              <div className={readmore ? "Readmore" : ""}>
                <p className="normaltext">
                  {" "}
                  <span className="specialprice">
                    Choose the Right Coverage:
                  </span>{" "}
                  Third-party insurance will do if you just want basic
                  protection against traffic fines. But for full-on vehicle
                  protection, go for a comprehensive policy.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">Decide on the IDV:</span> Aim
                  for an Insured Declared Value (IDV) that matches your car's
                  market value. While a lower IDV might lower your premium, it
                  could leave you with higher expenses if you need to make a
                  claim. You can use an online IDV calculator to help you figure
                  out the right value.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">
                    Check the Claim Settlement Ratio (CSR):{" "}
                  </span>
                  Before you commit, take a peek at the insurance company's
                  claim settlement ratio. A higher CSR means a better chance of
                  your claims getting sorted hassle-free.
                </p>

                <p className="normaltext">
                  <span className="specialprice">Cashless Garages:</span> Look
                  into the number of cashless network garages in your area. More
                  options mean more convenience when it comes to cashless
                  repairs.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">Smooth Claim Process: </span>
                  Opt for an insurer that promises a straightforward claim
                  process, round-the-clock support, and speedy settlements.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">
                    Compare Plans Online:{" "}
                  </span>{" "}
                  Don't settle for the first plan you see. Take the time to
                  compare multiple car insurance plans online to find the one
                  that fits your needs and budget.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">Customer Support: </span>Make
                  sure the insurance company offers 24x7 customer assistance.
                  This ensures you can get help with your queries and claims
                  whenever you need it.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">Worth of Your Car: </span>The
                  cost of your insurance policy should match with the value of
                  your vehicle.
                </p>

                <p className="normaltext">
                  {" "}
                  <span className="specialprice">
                    The kind of a driver you are:{" "}
                  </span>{" "}
                  How frequent you drive and the kind of a driver you are with.
                  Your driving habits matters a lot. What kind of a driver you
                  are, that does affect the cost of your insurance when you
                  apply for pay-as-you drive or pay-how-you drive options.
                </p>

                <p className="normaltext">
                  <span className="specialprice">
                    How much you are ready to pay from your own pocket:{" "}
                  </span>
                  This is completely as per your decided budget and how much
                  risk you can afford. If any accident happens, and if you are
                  not willing to or afford to spend money, from your own pocket
                  for the repairing of your car, then opt for your own damage
                  cover instead of a Third-Party-Policy.
                </p>

                <p className="normaltext">
                  <span className="specialprice">Area of your residence: </span>{" "}
                  Online car insurance costs can differ depending on the area of
                  your residence, such as crime rate in your area and traffic
                  conditions in your area
                </p>

                <p className="normaltext">
                  <span className="specialprice">
                    Type of coverage you need:
                  </span>{" "}
                  Navigate from the options from comprehensive, liability,
                  collision, and personal injury protection. Compare car
                  insurance quotes now and start saving.
                </p>

                <p className="normaltext">
                  <span className="specialprice">Discount Rates:</span> Navigate
                  the eligibility such as discounts for having multiple
                  policies, being a safe driver, or driving less.
                </p>
              </div>

              <div className="redbtn">
                <button className="Readmorebtn" onClick={handelReadmore}>
                  {readmore ? "Read More" : "Read Less"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Key Highlights of Car Insurance Policy
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md">
              <p className="normaltext" style={{ textAlign: "justify" }}>
                <span className="specialprice">Auto Insurance Costs -</span>{" "}
                There are two primary costs associated with purchasing car
                insurance: premiums and deductibles. Car insurance premiums vary
                based on the calculation and assessment of multiple factors. The
                following are the several factors: the gender of the applicant ,
                age at the time of applying, driving experience in number of
                years, accident and moving encroachment and contravention
                history, and several other factors. At the same time it’s a
                mandate in many states to pay a minimum amount of auto
                insurance. That minimum amount varies by state, but many people
                avail of additional insurance for their further protection.
                Above it, if you're financing a car, the lender may designate
                and guarantee that you carry certain types of car insurance. For
                example, you may need gap insurance if you're planning to buy an
                expensive vehicle that will diminish very quickly once you drive
                it off the lot. Gap insurance helps to pay off the difference in
                the price value between the value price of the vehicle and what
                you still owe on it if you're unfortunately involved in an
                accident. An indigent driving record or the wish for complete
                coverage will lead to paying higher premiums. Any which ways,
                you can cut back your premiums on agreeing upon to be adept with
                more risk, which states increasing your deductible. Deductible
                is the amount of money you have to pay while filing a claim
                before the insurer will pay out an amount to you for damages.
                For instance, your policy may have a $1000 or $1500 deductible.
                Agreeing and accepting a higher deductible can be a consequence
                of a lower premium, but you'd have to be justifiably sure you
                could cover the higher amount if you at all need to file a
                claim.
                <br />
                <span className="specialprice"> Key Point:</span> Clarify with
                your insurance company regarding how you can lower your car
                insurance rates, by availing a safe driving discount or taking a
                defensive driving course.
              </p>

              <div className="tableoverflow">
                <table className="keyHighlightsOfCarInsurancePolicy-table keyHighlightsOfCarInsurancePolicy-table-bordered">
                  <thead>
                    <tr>
                      <th>Si No.</th>
                      <th>Highlights</th>
                      <th>Benefits</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>Third-Party Cover</td>
                      <td>
                        Coverage for third-party injury and property damage
                      </td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Own Damage Cover</td>
                      <td>
                        Covers the damage and loss incurred by the insured
                        four-wheeler
                      </td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>Personal Accident Cover</td>
                      <td>Available up to 15 lakh</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>Add-on Covers</td>
                      <td>
                        Various add-ons are available based on the policy such
                        as zero depreciation cover, return to invoice cover,
                        roadside assistance, etc.
                      </td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>Cashless Claim</td>
                      <td>Available at the network garages of the insurer</td>
                    </tr>
                    <tr>
                      <td>6.</td>
                      <td>No Claim Bonus</td>
                      <td>Up to 50%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Aspects That Influence Car Insurance Quotes
          </h1>
          <div className="yellowline"></div>

          <p className="normaltext">
            A car insurance quote might not give you an exact figure for how
            much you will pay for the coverage, it can provide an estimate of
            the premium that a provider offers. Traditionally, insurance
            companies regulate premiums based on rates and underwriting, the
            method by which an insurance company analyzes an insurance
            applicant’s risk and the likelihood that they’ll file for claims.{" "}
          </p>
          <div className="row">
            <div className="col-md">
              <div className="separtaediv">
                <div className="numberingspancar">1</div>
                <div className="separatetext">
                  <p>
                    {" "}
                    &nbsp;Let’s say, a driver who has moving violations and
                    traffic accidents under their name on their driving record
                    is considered to have higher risk compared to the person who
                    has a clean driving record under his/her name and will
                    usually have a higher premium.
                  </p>
                </div>
              </div>
              <div className="separtaediv">
                <div className="numberingspancar">2</div>
                <div className="separatetext">
                  <p>
                    &nbsp;Premiums can vary throughout the life of a policy,
                    depending on changes in the risk level. The general rating
                    factors of an applicant are as follow:
                  </p>
                </div>
              </div>

              <div className="container">
                <div className="row">
                  <div className="col-md-6 mt-4">
                    <div className="cardocreq">
                      <li>
                        <GrDocumentText />
                        &nbsp;Age
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Annual mileage
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Claims history
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Coverages
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Credit history
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Deductibles
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Driving experience
                      </li>
                    </div>
                  </div>
                  <div className="col-md-6 mt-4">
                    <div className="cardocreq2">
                      <li>
                        <GrDocumentText />
                        &nbsp;Driving record
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Gender
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Location
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Marital status
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Previous car insurance coverage
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Vehicle make and model
                      </li>
                      <li>
                        <GrDocumentText />
                        &nbsp;Vehicle use (personal or commercial)
                      </li>
                    </div>
                  </div>
                </div>
              </div>

              <div className="separtaediv">
                <div className="numberingspancar">A</div>
                <p>
                  Sometimes, certainly you can minimize your premium by reducing
                  the risk imposed to the insurer. For an instance, if you rent
                  an apartment in an area
                </p>
              </div>

              <div className="separtaediv">
                <div className="numberingspancar">B</div>
                <p>
                  Your location may also pose a higher risk if you live in a
                  residential location susceptible to severe weather conditions,
                  such as floods, cyclones, hailstorms, hurricanes, and
                  tornadoes.
                </p>
              </div>

              <div className="separtaediv">
                <div className="numberingspancar">C</div>
                <p>
                  You may also minimize your rate by developing or increasing
                  your deductible—the portion of a claim you must pay out of
                  pocket—or by dropping optional coverages you don’t require.
                </p>
              </div>

              <p className="normaltext">
                An expanding number of insurance providers now offer usage-based
                insurance (UBI) programs, which fix the premiums depending on
                the driving habits of a motorist. For example, for the drivers
                who maintain safe driving habits, avoiding late-night trips and
                speeding, a UBI program may provide a lower premium than a
                traditionally rated insurance policy.
              </p>

              <span className="specialprice">
                From where can we get a quote for car insurance? 
              </span>

              <p className="normaltext">
                While looking for car insurance quotes, try a comprehensive
                approach. You can receive quotes in several ways:
              </p>

              <div className="separtaediv">
                <div>
                  <li>
                    Internet is the medium of receiving information from
                    national and regional sources.
                  </li>
                  <li>
                    Receiving quotes on the phone and online from independent
                    individual insurance agents or brokers.
                  </li>
                  <li>
                    Upon meeting a person in person or receiving quotes from an
                    insurance agent.
                  </li>
                </div>
              </div>

              <p className="normaltext">
                While requesting for quotes, without failing follow a few thumb
                rules to ensure you receive the best possible estimates and the
                best car insurance rates to bypass the drawbacks:
              </p>

              <p className="normaltext">
                While requesting for quotes, without failing follow a few thumb
                rules to ensure you receive the best possible estimates and the
                best car insurance rates to bypass the drawbacks:
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div>
                {QNAARRAY.slice(1, 5).map((data) => (
                  <Accordion
                    key={`panel${data.id}`}
                    expanded={expanded === `panel${data.id}`}
                    onChange={handleChangese(`panel${data.id}`)}
                  >
                    <AccordionSummary
                      expandIcon={<MdOutlineExpandMore />}
                      aria-controls={`panel1-content`}
                      id={`panel1-header`}
                      className="accordingback"
                    >
                      <li className="listcol">{data.Q}</li>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="normaltext">{data.A}</p>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <div>
                {QNAARRAY.slice(5, 9).map((data) => (
                  <Accordion
                    key={`panel${data.id}`}
                    expanded={expanded === `panel${data.id}`}
                    onChange={handleChangese(`panel${data.id}`)}
                  >
                    <AccordionSummary
                      expandIcon={<MdOutlineExpandMore />}
                      aria-controls={`panel2-content`}
                      id={`panel2-header`}
                      className="accordingback"
                    >
                      <li className="listcol">{data.Q}</li>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="normaltext">{data.A}</p>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Is Covered Under Car Insurance Policy ?
          </h1>
          <div className="yellowline"></div>

          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/car_13561724.png?updatedAt=1727941203143"
                className="fmailimagegifs"
                width={auto}
                height={auto}
                alt={"Car Insurance in India"}
              />
            </div>
            <div className="col-md-6">
              {QNAARRAYCover.slice(0, isVisible ? QNAARRAYCover.length : 5).map(
                (data, index) => (
                  <p className="normaltext" key={index}>
                    <span className="specialprice">{data.Q}</span>: {data.A}
                  </p>
                )
              )}
              {QNAARRAYCover.length > 5 && (
                <button onClick={handleToggle} className="Readmorebtn">
                  {isVisible ? "Show Less" : "Read More"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Is Not Covered Under Car Insurance Policy ?
          </h1>
          <div className="yellowline"></div>

          <div className="row">
            <div className="col-md-6">
              {QNAARRAY2.slice(0, isVisible ? QNAARRAY2.length : 5).map(
                (data, index) => (
                  <p className="normaltext" key={index}>
                    <span className="specialprice">{data.Q}</span>: {data.A}
                  </p>
                )
              )}
              {QNAARRAY2.length > 5 && (
                <button onClick={handleToggle} className="Readmorebtn">
                  {isVisible ? "Show Less" : "Read More"}
                </button>
              )}
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/car_13561724.png?updatedAt=1727941203143"
                className="fmailimagegifs"
                width={auto}
                height={auto}
                alt={"Car Insurance in India"}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How To Choose Car Insurance Policy Online?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6">
              {QNAARRAY3.slice(0, 4).map((data) => (
                <Accordion
                  key={`panel${data.id}`}
                  expanded={expanded === `panel${data.id}`}
                  onChange={handleChangese(`panel${data.id}`)}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls={`panel2-content`}
                    id={`panel2-header`}
                    className="accordingback"
                  >
                    <li className="listcol">{data.Q}</li>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p className="normaltext">{data.A}</p>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
            <div className="col-md-6">
              {QNAARRAY3.slice(4, 8).map((data) => (
                <Accordion
                  key={`panel${data.id}`}
                  expanded={expanded === `panel${data.id}`}
                  onChange={handleChangese(`panel${data.id}`)}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls={`panel2-content`}
                    id={`panel2-header`}
                    className="accordingback"
                  >
                    <li className="listcol">{data.Q}</li>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p className="normaltext">{data.A}</p>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why Is Car Insurance Important In India?
          </h1>

          <div className="yellowline"></div>
          <p className="normaltext">
            Car insurance is essential in India for several reasons. Firstly, it
            provides financial protection against damages caused to your vehicle
            due to accidents, theft, or natural disasters. Secondly, it covers
            third-party liabilities, ensuring that you are protected from legal
            claims arising from injuries or property damage to others.
          </p>
          <div className="row">
            <div className="col-md-6 mb-4 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/car-insurance_4801890.png?updatedAt=1727943486336"
                width={auto}
                height={auto}
                className="fmailimagegifs"
                alt={"Car Insurance in India"}
              />
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                {QNAARRAY4.slice(0, showAll ? QNAARRAY4.length : 5).map(
                  (data, index) => (
                    <p className="normaltext" key={index}>
                      <span className="specialprice">{data.Q}</span>
                      {data.A}
                    </p>
                  )
                )}
                {QNAARRAY4.length > 5 && (
                  <button onClick={toggleShowAll} className="Readmorebtn">
                    {showAll ? "Show Less" : "Read More"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="healthHeading">
                How to Buy Car Insurance Online?
              </h1>
              <div className="yellowline"></div>
              <p className="normaltext">
                In few Easy Steps Buy Car Insurence Policy Online Via Beema1.com
              </p>
              <div className="row">
                {/* <p>Getting car insurance online is easy and straightforward. Here's a simple guide to help you find the perfect car insurance:</p>
    
   <b>Enter Your Car Information:-</b>
   
   <span>
   Simply input details about your car, including its make, model, and more, to discover the car insurance rates provided by leading insurers in India.
   </span>
   <b>Compare Car Insurance Quotes</b>
   <span>Explore the various car insurance plans on offer and choose the one that aligns perfectly with your budget and needs.</span>
   
   <b>Make Payment Online</b>
   <span>
   Complete your transaction by paying the policy premium online, and receive your car insurance documents instantly in your email inbox.
   </span> */}

                <div className="col-md-6 d-flex justify-content-center align-items-center">
                  <div style={{ width: "100%" }}>
                    <div className="carstepper">
                      <div className="numberstepper">1</div>Enter Your Car
                      Information
                    </div>
                    <div className="carstepper">
                      <div className="numberstepper">2</div>Compare Car
                      Insurance Quotes
                    </div>
                    <div className="carstepper">
                      <div className="numberstepper3">3</div>Make Payment Online
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                  <FastImage
                    url="/Website%20Img/values_5235607.png?updatedAt=1727945283486"
                    width={auto}
                    height={auto}
                    className="fmailimagegifscarstepper"
                    alt={"Car Insurance in India"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Documents Required To Avail Four-Wheeler Insurance Online
          </h1>
          <div className="yellowline"></div>
          <p className="normaltext">
            Here's what you need to have ready when buying car insurance online:
          </p>
          <div className="row">
            <div className="col-md-6 mt-4">
              <div className="documentdivcarinsurence">
                <li>
                  <IoDocumentTextOutline /> &nbsp; Vehicle registration paper or
                  RC
                </li>
                <li>
                  <IoDocumentTextOutline /> &nbsp;Policyholder's driving license
                </li>
                <li>
                  <IoDocumentTextOutline /> &nbsp;Aadhaar card or PAN card
                </li>
              </div>
            </div>
            <div className="col-md-6 mt-4">
              <div className="documentdivcarinsurence2">
                <li>
                  <IoDocumentTextOutline /> &nbsp;Recent passport-size photo of
                  the policyholder
                </li>
                <li>
                  <IoDocumentTextOutline /> &nbsp;Duly-signed car insurance form
                </li>
                <li>
                  <IoDocumentTextOutline /> &nbsp;Copy of NOC, if necessary
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Renew Car Insurance Policy Online | Up to 75%* Off
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <span className="specialprice">
                Know Your Benefits of Car Insurance Renewal Online:-
              </span>

              <p className="normaltext">
                A new car insurance has a validity period after which it needs
                to be renewed. That's why it's essential to renew your policy
                before it expires. Renewing your car insurance online offers a
                host of benefits, making it a convenient and wise choice.
              </p>

              <span className="specialprice">
                {" "}
                Easy Comparison of Four-Wheeler Renewal Online:-
              </span>

              <p className="normaltext">
                Renewing your insurance online offers a plethora of advantages.
                Firstly, it allows you to effortlessly compare plans from
                various insurers, giving you a clear picture of what each offer.
                You can also explore additional services like free pick-up and
                drop facility, 3-day repair assistance, cashless assurance, and
                self-video claims.
              </p>

              <p className="normaltext">
                <span className="specialprice">Easy Customization</span>
                You can easily modify the coverage of your car insurance policy
                during renewal by adding or removing the add-on covers. However,
                keep in mind that these add-ons can impact your car's premium.
              </p>

              <span className="specialprice">Easy to Switch the Insurer</span>
              <p className="normaltext">
                Switching insurers is another benefit of online renewal. If
                you're not satisfied with your current provider or find better
                features elsewhere, you can easily make the switch from the
                comfort of your home.
              </p>

              <span className="specialprice">Secured & Transparent</span>

              <p className="normaltext">
                The process is not only convenient but also secure and
                transparent. Secure payment gateways ensure your transactions
                are safe, and you can make premium payments using credit cards,
                debit cards, or UPI.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">How To File A Car Insurance Claim?</h1>
          <div className="yellowline"></div>
          <p className="normaltext">
            Understanding the right steps to file a car insurance claim is
            crucial, as any misstep could lead to claim rejection by your
            insurer. Follow these steps to smoothly raise a valid claim for your
            four-wheeler insurance:
          </p>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/insurance_8701171.png?updatedAt=1727948093490"
                width={auto}
                height={auto}
                className="fmailimagegifscarstepper"
                alt={"Car Insurance in India"}
              />
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div style={{ width: "100%" }}>
                <div
                  className="clamecarinsurence"
                  onClick={() => toggleOpen("1")}
                >
                  <div className="clameNumber">1</div>
                  <div className="flexdivs">
                    Report the Incident{" "}
                    {activeId === "1" ? <FaAngleUp /> : <FaAngleDown />}
                  </div>
                </div>
                {activeId === "1" && (
                  <div className="carclamediscription">
                    As soon as an accident occurs, notify your insurer
                    immediately. Provide comprehensive details of the incident
                    and support your claim with photographic evidence, if
                    possible.
                  </div>
                )}

                <div
                  className="clamecarinsurence"
                  onClick={() => toggleOpen("2")}
                >
                  <div className="clameNumber">2</div>
                  <div className="flexdivs">
                    Vehical inspetion{" "}
                    {activeId === "2" ? <FaAngleUp /> : <FaAngleDown />}
                  </div>
                </div>
                {activeId === "2" && (
                  <div className="carclamediscription">
                    Once the claim is filed, the insurer will send a surveyor to
                    assess the damage. Keep all relevant documents ready for
                    verification during this process.
                  </div>
                )}

                <div
                  className="clamecarinsurence"
                  onClick={() => toggleOpen("3")}
                >
                  <div className="clameNumber">3</div>
                  <div className="flexdivs">
                    Repairs {activeId === "3" ? <FaAngleUp /> : <FaAngleDown />}
                  </div>
                </div>
                {activeId === "3" && (
                  <div className="carclamediscription">
                    After the inspection, you can proceed to send your car to a
                    network garage for repairs.
                  </div>
                )}

                <div
                  className="clamecarinsurence"
                  onClick={() => toggleOpen("4")}
                >
                  <div className="clameNumber">4</div>
                  <div className="flexdivs">
                    Settlement{" "}
                    {activeId === "4" ? <FaAngleUp /> : <FaAngleDown />}
                  </div>
                </div>
                {activeId === "4" && (
                  <div className="carclamediscription">
                    If you have opted for cashless claim settlement, the insurer
                    will directly settle the repair bills with the network
                    garage. For reimbursement claims, you'll need to pay the
                    bills upfront and then file for reimbursement later.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">Car Insurance Claim Settlement</h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="normaltext">
                Nobody can specify how long it actually takes to process a car
                insurance claim, but in India usually car insurance companies
                aim for the settlement of a claim within a month of time. Car
                insurance claims may take days, weeks, or even over a month to
                get resolved, and insurance companies have to settle accepted
                claims. Depending on the gravity of the impairment or damage
                caused to your car, the time of settling your claim is
                determined. The claim settlement process also depends on facts
                like whether it’s clear who was responsible for the damage, and
                how fast you provide with all the important and essential
                information to the insurance company. The turnaround time for
                the settlement of your car insurance claim also depends on the
                type of claim you make.
              </p>

              <p className="normaltext">
                <span className="specialprice">
                  Total Percentage of claims settled is 75.60% in terms of Motor
                  Insurance, as per IRDAI Annual Report 2022-2023. When you plan
                  to invest your hard-earned money in any car insurance company
                  you should know the IRDA car insurance claim settlement ratio
                  of the same.
                </span>
              </p>

              <p className="normaltext">
                The term claim settlement in terms of car insurance symbolizes
                the right of every policyowner to be reimbursed for the
                financial costs that they incurred due to mishaps such as
                accidents that involved their vehicles. As a policyholder, as
                you file a claim with your insurer, the latter pays you for the
                financial liability that has taken place. This is done based on
                the scope and nature of the policy that is in question. It is
                mandatory and a wise choice of looking at the CSR percentage of
                an insurance company before selecting the same for yourself.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <div className="row">
            <div className="col-md">
              <div className="tebildivs">
                <div className="tableoverflow">
                  <table className="company-table">
                    <thead>
                      <tr className="company-table-header">
                        <th className="company-table-header-cell">
                          Motor Insurence
                        </th>
                        <th className="company-table-header-cell">2021-22</th>
                        <th className="company-table-header-cell">2022-23</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="company-table-cell">
                          Zuno General Insurance Co. Ltd.
                        </td>
                        <td className="company-table-cell">84.61</td>
                        <td className="company-table-cell">79.83</td>
                      </tr>
                      <tr>
                        <td className="company-table-cell">
                          Bajaj Allianz General Insurance Co. Ltd.
                        </td>
                        <td className="company-table-cell">68.53</td>
                        <td className="company-table-cell">74.48</td>
                      </tr>
                      <tr>
                        <td className="company-table-cell">
                          Go Digit General Insurance Ltd.
                        </td>
                        <td className="company-table-cell">79.54</td>
                        <td className="company-table-cell">68.76</td>
                      </tr>
                      <tr>
                        <td className="company-table-cell">
                          HDFC ERGO General Insurance Co. Ltd.
                        </td>
                        <td className="company-table-cell">74.66</td>
                        <td className="company-table-cell">78.09</td>
                      </tr>
                      <tr>
                        <td className="company-table-cell">
                          ICICI Lombard General Insurance Co. Ltd.
                        </td>
                        <td className="company-table-cell">70.88</td>
                        <td className="company-table-cell">72.4</td>
                      </tr>
                      <tr>
                        <td className="company-table-cell">
                          Reliance General Insurance Co. Ltd.
                        </td>
                        <td className="company-table-cell">75.57</td>
                        <td className="company-table-cell">79.62</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <section className="type-insurance">
        <Typeofpolicy/>
      </section> */}

      <PartnerCompany />
      <FAQ />
    </div>
  );
};

export default Carinsurence;
